module.exports = __webpack_public_path__ + "img/lol.627c4cbe.png";